export default "__VITE_ASSET__CYG0pU1y__"